import * as Yup from 'yup';

export default function LoginValidationSchema(){
    return Yup.object().shape({
        email: Yup.string().matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/,'Invalid email').required('Required'),
        password: Yup.string().required('Required').max(20). min(3)
    })

}